import styled from 'styled-components';
import colors from '../../style/colors';
import { BoxProps } from '../box';
import BaseCard from './base-card';

const SkyLightCard = styled(BaseCard)<BoxProps>`
  height: auto;
  width: auto;
  &:hover {
    background: ${colors.surfaceSecondary};
  }
  transition: all 0.3s ease;

  cursor: pointer;
`;

export default SkyLightCard;
